import { render, staticRenderFns } from "./MediationRequest.vue?vue&type=template&id=42560684"
import script from "./MediationRequest.vue?vue&type=script&lang=js"
export * from "./MediationRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports